export const getRuntimeTotals = (data) => {
  let runningTotal = 0;
  data.values.map((runtimeItem) => {
    runtimeItem.dimensions.values.map((actionItem) => {
      runningTotal += parseInt(actionItem.value);
    });
  });
  return runningTotal;
};
